<div
  class="d-flex flex-column h-inherit w-inherit"
  #notificationsAnchor ="kendoPopoverAnchor"
  kendoPopoverAnchor
  rcClickOutside
  (clickOutside)="notificationsAnchor.hide()"
  [popover]="notificationPopover"
  [showOn]="'none'"
  (click)="notificationsAnchor.toggle()"
  [tabIndex]="0"
>
  @let notificationsLabel = "NOTIFICATIONS_TITLE" | translate | capitalize;
  <button
    kendoButton
    kendoTooltip
    #bellBtn
    position="bottom"
    [offset]="12"
    tooltipClass="tooltip-arrow-top"
    class="k-button-clear notifications-button h-inherit w-inherit p-0"
    [title]="notificationsLabel"
    [attr.aria-label]="notificationsLabel"
  >
    <i [class]="(notifications().length ? 'rc-icon-bell-ringing-filled rc-anim--wiggle' : 'rc-icon-bell')"></i>
  </button>

  <kendo-popover
    #notificationPopover
    [offset]="12"
    [width]="popoverWidth()"
    [animation]="false"
    [callout]="false"
    position="bottom"
  >
    <ng-template kendoPopoverTitleTemplate>
      <div class="title-row k-d-flex k-justify-content-between k-align-items-center">
        <div class="k-d-flex k-align-items-center k-gap-2 position-relative">
          <h3 class="title">{{ "NOTIFICATIONS_TITLE" | translate | capitalize }}</h3>
          <span class="number-highlight">{{ notifications().length }}</span>
        </div>

        @if (notifications().length) {
          <a tabindex="0" (keydown.enter)="markAllAsRead()" (click)="markAllAsRead()">
            {{ "NOTIFICATIONS_MARK_ALL_READ" | translate | capitalize }}
          </a>
        }
      </div>
    </ng-template>
    <ng-template kendoPopoverBodyTemplate>
      <!-- 👇 opt-in once: hooks the global rc-popover skin -->
      <div class="rc-popover rc-popover-skin rc-popover--no-callout user-notification-content">


        @if (notifications().length === 0) {
          <div class="notification-empty g-col-4 notification-item d-flex flex-column">
            {{ "NO_NEW_NOTIFICATIONS" | translate | capitalize }}
          </div>
        } @else {
          <div class="scroll-hints-wrapper"
               rcScrollHints
               [rcScrollContainer]="notificationGrid"
               [iconUpClass]="'rc-icon-arrow-narrow-up'"
               [iconDownClass]="'rc-icon-arrow-narrow-down'"
               [iconSize]="'16px'">
            <div class="grid template-cols-4 notification-grid gap-4" #notificationGrid data-rc-scroll-container>
              @for (notification of notifications(); track notification['@id']) {
                <div class="g-col-4 notification-item d-flex flex-column">
                  <div class="g-col-4 notification-item d-flex flex-column">
                    <div class="d-flex flex-row">
                      <p class="title {{ notification.isRead ? 'read' : '' }}">{{ notification.title }}</p>
                      @if (!notification.isRead) { <span class="notification-pulse"></span> }
                    </div>

                    <div class="d-flex flex-row">
                      <p class="description">
                        {{ notification.createdOn | kendoDate: "dd/MM/yyyy" }} •
                        {{ notification.createdOn | kendoDate: "HH:mm:ss" }}
                        {{ notification.description }}
                      </p>
                    </div>

                    <div class="d-flex flex-row">
                      @if (notification.referralPath) {
                        <button
                          kendoButton
                          type="button"
                          class="k-button-solid-primary me-3"
                          (click)="openReferral(notification)">
                          {{ "OPEN" | translate | capitalize }}
                        </button>
                      }
                      <button
                        kendoButton
                        type="button"
                        class="k-button-solid-secondary"
                        [disabled]="notification.isRead"
                        (click)="markNotificationAsRead(notification)">
                        {{ "MARK_AS_READ" | translate | capitalize }}
                      </button>
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </ng-template>
  </kendo-popover>
</div>
